export default "/images/7a2ecbfd9f6c17b51beb26820690fffe.avif";